import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchUserRollingArrangements } from 'actions/rollingArrangements';
import { getUserRollingArrangements } from 'reducers';

const withActiveRollingArrangement = (DecoratedComponent) => {
  class WithActiveRollingArrangement extends Component {
    state = {
      activeRollingArrangement: null,
    };

    componentDidMount() {
      if (this.props.purchase) {
        this.fetchUserRollingArrangements();
      }
    }

    componentDidUpdate(oldProps, prevState) {
      const newPurchase = this.props.purchase;
      const oldPurchase = oldProps.purchase;
      if (
        (newPurchase && !oldPurchase) ||
        (newPurchase && oldPurchase && newPurchase.id !== oldPurchase.id)
      ) {
        this.fetchUserRollingArrangements();
      }

      if (newPurchase) {
        const { userRollingArrangements } = this.props;
        const activeRollingArrangement = userRollingArrangements.find(
          (rollingArrangement) => rollingArrangement.active === newPurchase.id,
        );

        if (
          activeRollingArrangement &&
          prevState.activeRollingArrangement !== activeRollingArrangement
        ) {
          this.setState({ activeRollingArrangement });
        }
      }
    }

    fetchUserRollingArrangements() {
      const { purchase, fetchUserRollingArrangements } = this.props;

      if (!purchase || purchase.status !== 'arranged') {
        return; // don't need to load data;
      }

      fetchUserRollingArrangements(purchase.user_profile);
    }

    render() {
      const { children, ...props } = this.props;
      const { activeRollingArrangement } = this.state;

      return React.createElement(
        DecoratedComponent,
        {
          ...props,
          activeRollingArrangement,
        },
        children,
      );
    }
  }

  const mapStateToProps = (state) => ({
    userRollingArrangements: getUserRollingArrangements(state),
  });

  const mapDispatchToProps = {
    fetchUserRollingArrangements,
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WithActiveRollingArrangement);
};

export default withActiveRollingArrangement;
